import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Satellite, CreateSatelliteDto } from 'types';

export const createSatellite = (
  data: CreateSatelliteDto
): Promise<Satellite> => {
  return axios.post('/api/satellites', data);
};

type UseCreateSatelliteOptions = {
  config?: MutationConfig<typeof createSatellite>;
};

export const useCreateSatellite = ({ config }: UseCreateSatelliteOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousSatellites) {
        queryClient.setQueryData(['satellites'], context.previousSatellites);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['satellites']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createSatellite,
  });
};
